// @flow

import { toastr } from "react-redux-toastr";

import { makeApiCall } from "../../../../../services/apiService/apiService";

export const createTicketActions = {
  GET_ALL_TICKET_TYPES: "GET_ALL_TICKET_TYPES",
  GET_ALL_CATEGORIES: "GET_ALL_CATEGORIES",
  GET_TICKET_TYPE_DTO: "GET_TICKET_TYPE_DTO",
  CREATE_TICKET_SUBMIT: "CREATE_TICKET_SUBMIT",
  GET_CNOTE_INFO_DETAILS: "GET_CNOTE_INFO_DETAILS",
  GET_PRQ_INFO_DETAILS: "GET_PRQ_INFO_DETAILS",
  GET_ASSIGNEE_OPTIONS: "GET_ASSIGNEE_OPTIONS",
  GET_ORG_CLIENT_DETAILS: "GET_ORG_CLIENT_DETAILS",
  GET_USER_INFO: "GET_USER_INFO",
  GET_CLIENT_CODE_OPTIONS: "GET_CLIENT_CODE_OPTIONS",
  GET_PRIME_CLIENT_CODE_OPTIONS: "GET_PRIME_CLIENT_CODE_OPTIONS",
  GET_FILTERED_PRIME_CLIENT_CODE_OPTIONS:
    "GET_FILTERED_PRIME_CLIENT_CODE_OPTIONS",
  GET_CC_EMAIL_DETAILS: "GET_CC_EMAIL_DETAILS",
  GET_ALL_BU_TYPES: "GET_ALL_BU_TYPES",
  GET_ENTITY_TYPES: "GET_ENTITY_TYPES",
  CLEAR_STATE: "CLEAR_STATE",
  GET_ALL_LOCATIONS_DATA: "GET_ALL_LOCATIONS"
};

export const getAllCategoriesAction = (obj: Object) => ({
  type: createTicketActions.GET_ALL_CATEGORIES,
  payload: obj
});

export const getAllTicketTypesAction = (obj: Object) => ({
  type: createTicketActions.GET_ALL_TICKET_TYPES,
  payload: obj
});

export const getTicketTypeDTOAction = (obj: Object) => ({
  type: createTicketActions.GET_TICKET_TYPE_DTO,
  payload: obj
});

export const createTicketSubmitAction = (obj: Object) => ({
  type: createTicketActions.CREATE_TICKET_SUBMIT,
  payload: obj
});

export const getOrgClientInfoDetailAction = (obj: Object) => ({
  type: createTicketActions.GET_ORG_CLIENT_DETAILS,
  payload: obj
});

export const getUserInfoAction = (obj: Object) => ({
  type: createTicketActions.GET_USER_INFO,
  payload: obj
});

export const getAssigneeOptionsAction = (obj: Object) => ({
  type: createTicketActions.GET_ASSIGNEE_OPTIONS,
  payload: obj
});

export const getClientCodeOptionsAction = (obj: Object) => ({
  type: createTicketActions.GET_CLIENT_CODE_OPTIONS,
  payload: obj
});

export const getPrimeClientCodeOptionsAction = (obj: Object) => ({
  type: createTicketActions.GET_PRIME_CLIENT_CODE_OPTIONS,
  payload: obj
});

export const getFilteredPrimeClientCodeOptionsAction = (obj: Object) => ({
  type: createTicketActions.GET_FILTERED_PRIME_CLIENT_CODE_OPTIONS,
  payload: obj
});

export const getCcEmailDetailsAction = (obj: Object) => ({
  type: createTicketActions.GET_CC_EMAIL_DETAILS,
  payload: obj
});

export const getBuTypesAction = (obj: Object) => ({
  type: createTicketActions.GET_ALL_BU_TYPES,
  payload: obj
});

export const getEntityTypesAction = (obj: Object) => ({
  type: createTicketActions.GET_ENTITY_TYPES,
  payload: obj
});

export const clearStateAction = () => ({
  type: createTicketActions.CLEAR_STATE
});

export const getLocationDataAction = (obj: Object) => ({
  type: createTicketActions.GET_ALL_LOCATIONS_DATA,
  payload: obj
});

export const getUserInfo = (param: String, isEmail: Boolean) => (
  dispatch: Function
) => {
  dispatch(
    getUserInfoAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  // eslint-disable-next-line no-console
  console.log(" UserInfo from create Ticket ", param);
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: isEmail ? "getUserInfoFromEmail" : "getUserInfoFromMobile",
    replaceParamsArr: isEmail
      ? [{ key: "email", val: param }]
      : [{ key: "mobileNo", val: param }],
    successCb: res => {
      //	eslint-disable-next-line
      console.log("Fetched UserInfo ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getUserInfoAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getUserInfoAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in fetching UserInfo, res= ", res);
      dispatch(
        getUserInfoAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in fetching UserInfo ", res);
      dispatch(
        getUserInfoAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getCcDetails = (param: String) => (dispatch: Function) => {
  dispatch(
    getCcEmailDetailsAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  // eslint-disable-next-line no-console
  console.log(" Cc details ", param);
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getUserInfoFromEmail",
    replaceParamsArr: [{ key: "email", val: param }],
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched Cc details ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getCcEmailDetailsAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getCcEmailDetailsAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in fetching cc details, res= ", res);
      dispatch(
        getCcEmailDetailsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in fetching cc details ", res);
      dispatch(
        getCcEmailDetailsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getEntityInfoDetails = (type, id) => (dispatch: Function) => {
  dispatch(
    getOrgClientInfoDetailAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  // eslint-disable-next-line no-console
  console.log(" entity Info from create Ticket ", id);
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getEntityInfo",
    pathVariables: [
      { key: "#type", val: type },
      { key: "#id", val: id }
    ],
    successCb: res => {
      //	eslint-disable-next-line
      console.log("Fetched entity Info ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getOrgClientInfoDetailAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getOrgClientInfoDetailAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in fetching entity Info, res= ", res);
      dispatch(
        getOrgClientInfoDetailAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in fetching entity Info ", res);
      dispatch(
        getOrgClientInfoDetailAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getBuTypes = () => (dispatch: Function) => {
  dispatch(
    getBuTypesAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getBuTypes",
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched all Bu Types ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getBuTypesAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getBuTypesAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in fetching oa matrics, res= ", res);
      dispatch(
        getBuTypesAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in fetching oa matrics ", res);
      dispatch(
        getBuTypesAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getAllCategories = buId => (dispatch: Function) => {
  dispatch(
    getAllCategoriesAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getGroupTypesByBu",
    pathVariables: [
      {
        key: "#buId",
        val: buId
      }
    ],
    successCb: res => {
      //	eslint-disable-next-line
      console.log("Fetched all categories for bu {}, {} ", buId, res);
      if (res.status === "SUCCESS") {
        dispatch(
          getAllCategoriesAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getAllCategoriesAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in fetching categories, res= ", res);
      dispatch(
        getAllCategoriesAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in fetching categories ", res);
      dispatch(
        getAllCategoriesAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getAllTicketTypes = buId => (dispatch: Function) => {
  dispatch(
    getAllTicketTypesAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getTicketTypes",
    pathVariables: [
      {
        key: "#buId",
        val: buId
      }
    ],
    successCb: res => {
      //	eslint-disable-next-line
      console.log("Fetched all Ticket Types for bu {}, {} ", buId, res);
      if (res.status === "SUCCESS") {
        dispatch(
          getAllTicketTypesAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getAllTicketTypesAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in fetching oa matrics, res= ", res);
      dispatch(
        getAllTicketTypesAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in fetching oa matrics ", res);
      dispatch(
        getAllTicketTypesAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getTicketTypeDTO = ticketTypeId => (dispatch: Function) => {
  dispatch(
    getTicketTypeDTOAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  // eslint-disable-next-line no-console
  console.log(" userInfo from create Ticket ", ticketTypeId);
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getTicketTypeDetail",
    replaceParamsArr: [{ key: "id", val: ticketTypeId }],
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched Ticket Type Detail ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getTicketTypeDTOAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getTicketTypeDTOAction({
            isLoading: false,
            isLoaded: true,
            data: {}
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in Ticket Type Detail, res= ", res);
      dispatch(
        getTicketTypeDTOAction({
          isLoading: false,
          isLoaded: true,
          data: {}
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in Ticket Type Detail ", res);
      dispatch(
        getTicketTypeDTOAction({
          isLoading: false,
          isLoaded: true,
          data: {}
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const createTicketSubmit = (formData: Object, isEdit: Boolean) => (
  dispatch: Function
) => {
  dispatch(
    createTicketSubmitAction({
      isLoading: true,
      isLoaded: false,
      data: null,
      allowAPIcall: false
    })
  );
  // eslint-disable-next-line no-console
  console.log(" userInfo from create Ticket ", formData);
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: isEdit ? "editTicketSubmit" : "createTicketSubmit",
    method: isEdit ? "PUT" : "POST",
    data: formData,
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched Ticket Create Submit ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          createTicketSubmitAction({
            isLoading: false,
            isLoaded: true,
            data: res.response,
            allowAPIcall: false
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          createTicketSubmitAction({
            isLoading: false,
            isLoaded: true,
            data: null,
            allowAPIcall: true
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in Ticket Create Submit, res= ", res);
      dispatch(
        createTicketSubmitAction({
          isLoading: false,
          isLoaded: true,
          data: null,
          allowAPIcall: true
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in Ticket Create Submit ", res);
      dispatch(
        createTicketSubmitAction({
          isLoading: false,
          isLoaded: true,
          data: null,
          allowAPIcall: true
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getAssigneeOptions = text => (dispatch: Function) => {
  dispatch(
    getAssigneeOptionsAction({
      isLoading: true,
      isLoaded: false,
      data: []
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getAssigneeOptions",
    replaceParamsArr: [{ key: "pattern", val: text }],
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched assign to options ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getAssigneeOptionsAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        // commened for UAT
        // toastr.error("Error", res.errorMessage);
        dispatch(
          getAssigneeOptionsAction({
            isLoading: false,
            isLoaded: true,
            data: []
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in assign to options, res= ", res);
      dispatch(
        getAssigneeOptionsAction({
          isLoading: false,
          isLoaded: true,
          data: []
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in assign to options ", res);
      dispatch(
        getAssigneeOptionsAction({
          isLoading: false,
          isLoaded: true,
          data: []
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getClientCodeOptions = text => (dispatch: Function) => {
  dispatch(
    getClientCodeOptionsAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getClientCodeOptions",
    method: "GET",
    pathVariables: [{ key: "#pattern", val: text }],
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched client code options ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getClientCodeOptionsAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getClientCodeOptionsAction({
            isLoading: false,
            isLoaded: true,
            data: []
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in client code options, res= ", res);
      dispatch(
        getClientCodeOptionsAction({
          isLoading: false,
          isLoaded: true,
          data: []
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in client code options ", res);
      dispatch(
        getClientCodeOptionsAction({
          isLoading: false,
          isLoaded: true,
          data: []
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getPrimeClientCodeOptions = () => (dispatch: Function) => {
  dispatch(
    getPrimeClientCodeOptionsAction({
      isLoading: true,
      isLoaded: false,
      data: [],
      filteredData: []
    })
  );
  const requestObj = {
    baseUrl: "primeOpcApiUrl",
    apiEndPoint: "getPrimeClients",
    method: "GET",
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched client code options ", res);
      dispatch(
        getPrimeClientCodeOptionsAction({
          isLoading: false,
          isLoaded: true,
          data: res,
          filteredData: res
        })
      );
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in client code options, res= ", res);
      dispatch(
        getPrimeClientCodeOptionsAction({
          isLoading: false,
          isLoaded: true,
          data: [],
          filteredData: []
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in client code options ", res);
      dispatch(
        getPrimeClientCodeOptionsAction({
          isLoading: false,
          isLoaded: true,
          data: [],
          filteredData: []
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getEntityTypes = () => (dispatch: Function) => {
  dispatch(
    getEntityTypesAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getTicketEntityTypes",
    successCb: res => {
      //	eslint-disable-next-line
      console.log("Fetched all entity types, {} ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getEntityTypesAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getEntityTypesAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in fetching entity types, res= ", res);
      dispatch(
        getEntityTypesAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in fetching entity types ", res);
      dispatch(
        getEntityTypesAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getLocationData = () => (dispatch: Function) => {
  dispatch(
    getLocationDataAction({
      isLoading: true,
      isLoaded: false,
      data: []
    })
  );

  const requestObj = {
    baseUrl: "zoomApiUrl",
    apiEndPoint: "getAllLocations",
    successCb: res => {
      // eslint-disable-next-line
      console.log("Fetched location data ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getLocationDataAction({
            isLoading: false,
            isLoaded: true,
            data: res.payload
          })
        );
      } else if (res.status === "FAILURE") {
        console.error("Error fetching location data", res.errorMessage);
        dispatch(
          getLocationDataAction({
            isLoading: false,
            isLoaded: true,
            data: []
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log("Failure in fetching location data ", res);
      dispatch(
        getLocationDataAction({
          isLoading: false,
          isLoaded: true,
          data: []
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log("Exception in fetching location data ", res);
      dispatch(
        getLocationDataAction({
          isLoading: false,
          isLoaded: true,
          data: []
        })
      );
    }
  };
  makeApiCall(requestObj);
};



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/createTicket/createTicketRedux/createTicketActionCreator.js